import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ManualRequestHistoryTable } from '@/entities/manual-request/ui/ManualRequestHistoryTable'

export const Route = createFileRoute(
  '/_auth/applications/manual-requests/manual-request/$requestId/history'
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <ManualRequestHistoryTable />
      <Outlet />
    </>
  )
}
